<template>
  <QBtn class="button" no-caps :class="dynamicClasses" :style="buttonStyle" @click="handleClick">
    <span><slot /></span>
  </QBtn>
</template>

<script>
  export default {
    props: {
      variant: {
        type: String,
        default: "filled",
      },
      color: {
        type: String,
        required: true,
      },
    },
    emits: ["click"],
    computed: {
      dynamicClasses() {
        return {
          "button--outlined": this.variant === "outlined",
          "button--filled": this.variant === "filled",
        };
      },
      buttonStyle() {
        return {
          color: this.color,
        };
      },
    },
    methods: {
      handleClick(event) {
        this.$emit("click");
        event.stopPropagation();
      },
    },
  };
</script>

<style lang="scss">
  .button {
    height: 35px;
    border-radius: 5px;
    width: 100%;
    font-size: 14px;
    cursor: pointer;
    padding: 0;

    span.q-btn__wrapper {
      padding: 0;
    }

    &--filled {
      background-color: currentColor;
      span {
        color: white;
      }
    }
    &--outlined {
      border: 1px solid currentColor;
      background-color: white;
    }
  }
</style>
